import Vue from 'vue'
import Router from 'vue-router'
import shop from '@/components/shop'
import noble from '@/components/noble'
import earnings from '@/components/earnings'
import invitation from '@/components/invitation'
import invitationSubordinate from '@/components/invitation_subordinate'
import invitationEarnings from '@/components/invitation_earnings'
import invitationRecord from '@/components/invitation_record'
import invitationWithdrawal from '@/components/invitation_withdrawal'
import invitationPinless from '@/components/invitation_pinless'
import invitationSuperior from '@/components/invitation_superior'
import invitationShare from '@/components/invitation_share'
import contact from '@/components/contact'
import emcee_center from '@/components/emcee_center'
import emcee_income_log from '@/components/emcee_income_log'
import emcee_center_select_live_time from '@/components/emcee_center_select_live_time'
import my_shop from '@/components/my_shop'
import create_shop from '@/components/create_shop'
import shop_manage from '@/components/shop_manage'
import shop_add from '@/components/shop_add'
import shop_product_list from '@/components/shop_product_list'
import vip from '@/components/vip'
import vip_grade from '@/components/vip_grade'
import vip_task from '@/components/vip_task'
import agent from '@/components/agent'
import UpSharemoney from '@/components/UpSharemoney'
import shareDownload from '@/components/shareDownload'
import invitationRules from '@/components/invitationRules'
import reflect from '@/components/reflect'
import firstlevelteam from '@/components/firstlevelteam'
import RealnameAuthentication from '@/components/RealnameAuthentication'
import download from '@/components/download'
import turntable from '@/components/turntable'
import greedy from '@/components/greedy'
import banding_bank from '@/components/banding_bank'
import agent_login from '@/components/agent_login'
import agent_admin from '@/components/agent_admin'
import video_rich_ranking from '@/components/video_rich_ranking'
import game_list from '@/components/game_list'
import game_picture_list from '@/components/game_picture_list'
import tulasi_game_view from '@/components/tulasi_game_view'
import month_statistics from '@/components/month_statistics'
import month_statistics_log from '@/components/month_statistics_log'
import avatar_frame from '@/components/avatar_frame'
import revenue_records from '@/components/revenue_records'
import play_svga from '@/components/play_svga'
import room_flow from '@/components/room_flow'
import item_shop from '@/components/item_shop'
import item_shop_car from '@/components/item_shop_car'
import item_shop_vip from '@/components/item_shop_vip'
import item_shop_lucky from '@/components/item_shop_lucky'
import item_shop_avatar from '@/components/item_shop_avatar'
import item_shop_my from '@/components/item_shop_my'
import banding_top_bank from '@/components/banding_top_bank'
import ranking_user from '@/components/ranking_user'

Vue.use(Router)
export default new Router({
  base: '/h5/',
  mode: 'history',
  routes: [
    {
      path: '/shop',
      name: 'shop',
      component: shop,
      meta: {
        title: '道具商城'
      }
    },
    {
      path: '/noble',
      name: 'noble',
      component: noble,
      meta: {
        title: '贵族列表'
      }
    },
    {
      path: '/earnings',
      name: 'earnings',
      component: earnings,
      meta: {
        title: '收益记录'
      }
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: invitation,
      meta: {
        title: '邀请奖励 --作废'
      }
    },
    {
      path: '/invitationSubordinate',
      name: 'invitationSubordinate',
      component: invitationSubordinate,
      meta: {
        title: '我的团队'
      }
    },
    {
      path: '/invitationSuperior',
      name: 'invitationSuperior',
      component: invitationSuperior,
      meta: {
        title: '我的上级'
      }
    },
    {
      path: '/invitationEarnings',
      name: 'invitationEarnings',
      component: invitationEarnings,
      meta: {
        title: '团队收益详情'
      }
    },
    {
      path: '/invitationRecord',
      name: 'invitationRecord',
      component: invitationRecord,
      meta: {
        title: '分销提现记录'
      }
    },
    {
      path: '/invitationWithdrawal',
      name: 'invitationWithdrawal',
      component: invitationWithdrawal,
      meta: {
        title: '分销提现'
      }
    },
    {
      path: '/invitationPinless',
      name: 'invitationPinless',
      component: invitationPinless,
      meta: {
        title: '绑定账号'
      }
    },
    {
      path: '/invitationShare',
      name: 'invitationShare',
      component: invitationShare,
      meta: {
        title: '邀请分享页面'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta: {
        title: '设置联系方式'
      }
    },
    {
      path: '/emcee_center',
      name: 'emcee_center',
      component: emcee_center,
      meta: {
        title: '主播中心'
      }
    },
    {
      path: '/emcee_income_log',
      name: 'emcee_income_log',
      component: emcee_income_log,
      meta: {
        title: '收入记录'
      }
    },
    {
      path: '/emcee_center_select_live_time',
      name: 'emcee_center_select_live_time',
      component: emcee_center_select_live_time,
      meta: {
        title: '直播时长查询'
      }
    },
    {
      path: '/my_shop',
      name: 'my_shop',
      component: my_shop,
      meta: {
        title: '我的小店'
      }
    },
    {
      path: '/create_shop',
      name: 'create_shop',
      component: create_shop,
      meta: {
        title: '创建店铺'
      }
    },
    {
      path: '/shop_manage',
      name: 'shop_manage',
      component: shop_manage,
      meta: {
        title: '店铺管理'
      }
    },
    {
      path: '/shop_add',
      name: 'shop_add',
      component: shop_add,
      meta: {
        title: '店铺管理'
      }
    },
    {
      path: '/shop_product_list',
      name: 'shop_product_list',
      component: shop_product_list,
      meta: {
        title: '商品管理'
      }
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        title: 'vip等级'
      }
    },
    {
      path: '/vip_grade',
      name: 'vip_grade',
      component: vip_grade,
      meta: {
        title: 'vip等级'
      }
    },
    {
      path: '/vip_task',
      name: 'vip_task',
      component: vip_task,
      meta: {
        title: 'vip任务升级'
      }
    },
    {
      path: '/agent',
      name: 'agent',
      component: agent,
      meta: {
        title: '分销等级'
      }
    },
		{
		  path: '/UpSharemoney',
		  name: 'UpSharemoney',
		  component: UpSharemoney,
		  meta: {
		    title: '更改分享赚钱'
		  }
		},{
		  path: '/shareDownload',
		  name: 'shareDownload',
		  component: shareDownload,
		  meta: {
		    title: '分享下载'
		  }
		},{
		  path: '/invitationRules',
		  name: 'invitationRules',
		  component: invitationRules,
		  meta: {
		    title: '邀请规则'
		  }
		},{
		  path: '/reflect',
		  name: 'reflect',
		  component: reflect,
		  meta: {
		    title: '提现'
		  }
		},{
		  path: '/firstlevelteam',
		  name: 'firstlevelteam',
		  component: firstlevelteam,
		  meta: {
		    title: '一级团队'
		  }
		},{
		  path: '/RealnameAuthentication',
		  name: 'RealnameAuthentication',
		  component: RealnameAuthentication,
		  meta: {
		    title: '实名认证'
		  }
		},
    {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/shareLive',
      name: 'shareLive',
      component: () => import('@/components/shareLive'),
      meta: {
        title: '分享直播间'
      }
    },
    {
      path: '/turntable',
      name: 'turntable',
      component: turntable,
      meta: {
        title: '转盘'
      }
    },
    {
      path: '/banding_bank',
      name: 'banding_bank',
      component: banding_bank,
      meta: {
        title: '绑定银行卡'
      }
    },
    {
      path: '/greedy',
      name: 'greedy',
      component: greedy,
      meta: {
        title: '贪婪的鱼'
      }
    },
    {
      path: '/agent_login',
      name: 'agent_login',
      component: agent_login,
      meta: {
        title: '平台代理登录'
      }
    },
    {
      path: '/agent_admin',
      name: 'agent_admin',
      component: agent_admin,
      meta: {
        title: '平台代理'
      }
    },
    {
      path: '/video_rich_ranking',
      name: 'video_rich_ranking',
      component: video_rich_ranking,
      meta: {
        title: '富豪榜'
      }
    }, {
      path: '/game_list',
      name: 'game_list',
      component: game_list,
      meta: {
        title: '游戏列表'
      }
    },
    {
      path: '/tulasi_game_view',
      name: 'tulasi_game_view',
      component: tulasi_game_view,
      meta: {
        title: 'Tulasi Game'
      }
    },
    {
      path: '/game_picture_list',
      name: 'game_picture_list',
      component: game_picture_list,
      meta: {
        title: '游戏列表-背景图'
      }
    },
    {
      path: '/month_statistics',
        name: 'month_statistics',
      component: month_statistics,
      meta: {
        title: '主播收益-月统计'
      }
    },
    {
      path: '/month_statistics_log',
        name: 'month_statistics_log',
      component: month_statistics_log,
      meta: {
        title: '主播收益-月统计记录'
      }
    },
    {
      path: '/avatar_frame',
      name: 'avatar_frame',
      component: avatar_frame,
      meta: {
        title: '头像框'
      }
    },
    {
      path: '/revenue_records',
      name: 'revenue_records',
      component: revenue_records,
      meta: {
        title: '主播收益记录'
      }
    },
    {
      path: '/play_svga',
      name: 'play_svga',
      component: play_svga,
      meta: {
        title: '播放svga'
      }
    },
    {
      path: '/room_flow',
      name: 'room_flow',
      component: room_flow,
      meta: {
        title: '房间流水'
      }
    },
    {
      path: '/item_shop',
      name: 'item_shop',
      component: item_shop,
      meta: {
        title: '道具商店'
      }
    },
    {
      path: '/item_shop_car',
      name: 'item_shop_car',
      component: item_shop_car,
      meta: {
        title: '道具商店:座驾'
      }
    },
    {
      path: '/item_shop_avatar',
      name: 'item_shop_avatar',
      component: item_shop_avatar,
      meta: {
        title: '道具商店:头像框'
      }
    },
    {
      path: '/item_shop_lucky',
      name: 'item_shop_lucky',
      component: item_shop_lucky,
      meta: {
        title: '道具商店:靓号'
      }
    },
    {
      path: '/item_shop_vip',
      name: 'item_shop_vip',
      component: item_shop_vip,
      meta: {
        title: '道具商店:VIP'
      }
    },
    {
      path: '/item_shop_my',
      name: 'item_shop_my',
      component: item_shop_my,
      meta: {
        title: '道具商店:我的道具'
      }
    },
    {
      path: '/banding_top_bank',
      name: 'banding_top_bank',
      component: banding_top_bank,
      meta: {
        title: '绑定top提现银行卡'
      }
    },
    {
      path: '/ranking_user',
      name: 'ranking_user',
      component: ranking_user,
      meta: {
        title: '排行榜'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js